import React from 'react';

import { SetState } from '../../../../types/helper';

import MobilePortraitDrawer from './Portrait';
import MpbileLandScapeDrawer from './Landscape';

export interface Props {
  isMobileDrawerOpen: boolean;
  setIsMobileDrawerOpen: SetState<boolean>;
  pages?: {
    thumnail: string;
    page: number;
    originalWidth: number;
    originalHeight: number;
  }[];
  translateKoToEn: (item: string) => string;
  blindPages?: number[] | null;
  isMobileLandscape: boolean;
}

const MobilePageNavigation = ({
  isMobileDrawerOpen,
  setIsMobileDrawerOpen,
  pages,
  translateKoToEn,
  blindPages,
  isMobileLandscape = false,
}: Props) => {
  return isMobileLandscape ? (
    <MpbileLandScapeDrawer
      isMobileDrawerOpen={isMobileDrawerOpen}
      setIsMobileDrawerOpen={setIsMobileDrawerOpen}
      pages={pages}
      translateKoToEn={translateKoToEn}
      blindPages={blindPages}
    />
  ) : (
    <MobilePortraitDrawer
      isMobileDrawerOpen={isMobileDrawerOpen}
      setIsMobileDrawerOpen={setIsMobileDrawerOpen}
      pages={pages}
      translateKoToEn={translateKoToEn}
      blindPages={blindPages}
    />
  );
};

export default React.memo(MobilePageNavigation);
